/**
 * Kinesitherapie Medicine Consultations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import AppConfig from "../../../constants/AppConfig";
import {store} from "../../store";

// States
const state = {
    KinesitherapieConsultations: [],
    KinesitherapieConsultation: {}
};

// Getters
const getters = {
    KinesitherapieConsultations: state => {
        return state.KinesitherapieConsultations
    },

    KinesitherapieConsultation: state => {
        return state.KinesitherapieConsultation
    }
};

// Actions
const actions = {
    printConsultationKinesitherapie(context, payload) {
        function successCallback(response) {
            let url= AppConfig.imgUrl+'/public/storage/pdf/'+response.data.name;
            let fileName = response.data.name;

            Vue.axios.get(
                url,{
                    responseType: 'blob', // important
                }
            ).then((response) => {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        }


        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Kinesitherapie.Print, localToken, successCallback, errorCallback, payload.errorMessages);
    },


    getKinesitherapieConsultations(context, payload) {
        function successCallback(response) {
            context.commit('getKinesitherapieConsultationsHandler', { consultations: response.data.consultations });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Kinesitherapie.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getKinesitherapieConsultation(context, payload) {
        function successCallback(response) {
            let consultation = response.data.kinesitherapie
            console.log(consultation);
            context.commit('getKinesitherapieConsultationHandler', { consultation:consultation  });
            context.commit('getMedicalFileHandler', { file: consultation.dossier });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Kinesitherapie.Show, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createKinesitherapieConsultation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            router.push({ name: 'consultation-kinesitherapie', params: { kinesitherapie: response.data.kinesitherapie.slug } });
        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');
        let url = AppConfig.apiUrl + apiModel.Consultation.Kinesitherapie.Create.url;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
        // makeApiRequest(payload.args, apiModel.Consultation.Kinesitherapie.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateKinesitherapieConsultation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            //Push to list of consultation
            // router.push({ name: 'consultations-Kinesitherapies' });

            //Push to edited consultation
            store.dispatch('findAndRemove', {name: 'consultation-Kinesitherapie' });

            router.push({ name: 'consultation-kinesitherapie', params: { consultation: response.data.kinesitherapie.slug } });
        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        let url = AppConfig.apiUrl + apiModel.Consultation.Kinesitherapie.Create.url + '/' + payload.consultation;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);

        // makeApiRequest(payload.args, apiModel.Consultation.Kinesitherapie.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteKinesitherapieConsultation(context, payload) {
        function successCallback(response) {
            // context.commit('deleteKinesitherapieConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
            router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.consultation.dossier.slug } }).href) +"#cardiologie");
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Kinesitherapie.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    archieveKinesitherapieConsultation(context, payload) {
        function successCallback(response) {
            context.commit('archieveKinesitherapieConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getKinesitherapieConsultationHandler', { consultation: response.data.kinesitherapie });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Kinesitherapie.Archieve, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    transmitKinesitherapieConsultation(context, payload) {
        function successCallback(response) {
            context.commit('getKinesitherapieConsultationHandler', { consultation: response.data.kinesitherapie });
            context.commit('transmitKinesitherapieConsultationHandler', { index: payload.index, successMessage: payload.successMessage });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Kinesitherapie.Transmit, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    reactiveKinesitherapieConsultation(context, payload) {
        function successCallback(response) {
            context.commit('reactiveKinesitherapieConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getKinesitherapieConsultationHandler', { consultation: response.data.kinesitherapie });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Kinesitherapie.Reactive, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    setAllergieHandler(state,{allergies}){
        if (state.KinesitherapieConsultation.hasOwnProperty('dossier')){
            let dossier = state.KinesitherapieConsultation.dossier;
            if (dossier.hasOwnProperty('allergies')){
                state.KinesitherapieConsultation.dossier.allergies = allergies;
            }
        }
    },

    setAntecedentHandler(state,{antecedents}){
        if (state.KinesitherapieConsultation.hasOwnProperty('dossier')){
            let dossier = state.KinesitherapieConsultation.dossier;
            if (dossier.hasOwnProperty('antecedents')){
                state.KinesitherapieConsultation.dossier.antecedents = antecedents;
            }
        }
    },

    getKinesitherapieConsultationsHandler(state, { consultations }) {
        // Update KinesitherapieConsultations state
        state.KinesitherapieConsultations = consultations;
    },

    getKinesitherapieConsultationHandler(state, { consultation }) {
        // Update KinesitherapieConsultation state
        state.KinesitherapieConsultation = consultation;
    },

    updateKinesitherapieKinesitherapieFileHandler(state,{files}){
        state.KinesitherapieConsultation.files = files
    },

    deleteKinesitherapieConsultationHandler(state, { index, successMessage }) {
        // let i = state.KinesitherapieConsultations.findIndex(consultation => consultation.slug === index);
        //
        // if (~i) {
        //     state.KinesitherapieConsultations.splice(i, 1);

        // router.push({ name: 'consultations-Kinesitherapies' });


        Vue.swal(
            payload.successMessage,
            '',
            'success'
        );
        // }
    },

    deleteConsultationPhysicalExamHandler(state, { index, successMessage }) {
        let i = state.physicalExams.findIndex(physicalExam => physicalExam.slug === index);

        if (~i) {
            state.physicalExams.splice(i, 1);

            router.push({ name: 'consultation-physical-exams' });

            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }
    },

    deleteConsultationComplementaryExamHandler(state, { index, successMessage }) {
        let i = state.complementaryExams.findIndex(complementaryExam => complementaryExam.slug === index);

        if (~i) {
            state.complementaryExams.splice(i, 1);

            router.push({ name: 'consultation-complementary-exams' });

            Vue.swal(
                successMessage,
                '',
                'error'
            );
        }
    },

    archieveKinesitherapieConsultationHandler(state, { index, successMessage }) {
        // router.push({ name: 'consultations-Kinesitherapies' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    reactiveKinesitherapieConsultationHandler(state, { index, successMessage }) {
        // router.push({ name: 'consultations-Kinesitherapies' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    transmitKinesitherapieConsultationHandler(state, { index, successMessage }) {
        // router.push({ name: 'consultations-Kinesitherapies' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}